import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import jwt_decode from "jwt-decode";
import { postData, postNoRestrict } from "../../../service/Service";

const initialAuthState = {
  data: "",
  dataToken: {
    iat: "",
    exp: "",
    roleId: "",
  },
  token: "",
  message: "",
  isError: false,
  isLogin: false,
};

export const submitLogin = createAsyncThunk(
  "users/login",
  async (loginData, { rejectWithValue }) => {
    try {
      const result = await postNoRestrict("/auth/login", loginData);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const addUserManagement = createAsyncThunk(
  "admin/auth/register",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/auth/register", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const authSlice = createSlice({
  name: "authentication",
  initialState: initialAuthState,
  reducers: {
    logout: (state) => {
      state = initialAuthState;
      return state;
    },
  },
  extraReducers: {
    [submitLogin.fulfilled]: (state, action) => {
      const encodeToken = jwt_decode(action.payload.data);
      state.message = "login sukses";
      state.data = action.payload;
      state.dataToken = encodeToken;
      state.token = action.payload.data;
      state.isLogin = true;
      state.isError = false;
    },
    [submitLogin.rejected]: (state, action) => {
      state.isError = true;
      state.message = action.payload.message;
    },
  },
});

export const authActions = authSlice.actions;

export default authSlice.reducer;
